export enum SplitPosition {
    vertical = "vertical",
    horizontal = "horizontal",
}
